<sm-title-bar
  [pageTitle]="mn + ' reward points'"
  [back]="true"
></sm-title-bar>
<div *ngIf="!loader">
  <div class="bradcamp_inventory">
    <div class="row">
      <div class="col-sm-3">
        <div class="overall_count_s">
          <p>Total</p>
          <h3>{{rewardData.total}} points</h3>
        </div>
      </div>
  
      <div class="col-sm-3">
        <div class="overall_count_s" style="border-right:none">
          <p>This month</p>
          <h3>{{rewardData.monthly}} points</h3>
        </div>
      </div>
       <div class="col-sm-6">
      <div class="create_btn_sd" style="position: relative; top: 10px" *ngIf="rewardTransactionData.length > 0">
        <button
          mat-button
          aria-label="option menu"
          color="accent"
          (click)="transferToWallet()"
        >
          <mat-icon class="material-icons-round try" [inline]="true"
            >account_balance_wallet</mat-icon
          >Transfer to wallet
        </button>
      </div>
    </div>
    </div>
  </div>
  
  <mat-card class="mt-3 main_boxx">
<sm-data-table
      [columnHeaders]="tableDisplayColumn"
      [dataSource]="rewardTransactionData"
      [showPagination]="true"
      [itemsPerPage]="25"
    ></sm-data-table>
  </mat-card>

</div>
